import isEqual from 'lodash/isEqual';
import CarPageApp from './car-page-app';

/**
 * Prototype for carPageApp sub components. Basic methods working, but feel free to override anything.
 */
class CarPageBasicComponent {
  app = null;
  state = {};
  controls = [];

  /**
   * Initializes the component: renders, binds, starts observers etc...
   * @param {CarPageApp} carPageApp carPageApp instance
   * @throws {TypeError} thrown if carPageApp parameter is not a instance of a CarPageApp class
   */
  constructor(carPageApp) {

    if( !(carPageApp instanceof CarPageApp) ) {
      throw new TypeError('Instance of CarPageApp instance expected')
    }

    this.app = carPageApp;
    this.initState();
    this.render();
    this.bind(['stateObserver']);
    this.app.registerStateObserver(this.stateObserver);
  }

  /**
   * Passed to controller as a callback. Called, when something happens in the app state.
   * @param  {object} nextState the entire next app state.
   */
  stateObserver(nextState) {
    this.setState(this.filterState(nextState));
  }

  /**
   * binds the .this context to given method, so they can be passed out as callbacks,
   * and still remember their context. (Avoiding using => because inheritance issues -> https://medium.com/@charpeni/arrow-functions-in-class-properties-might-not-be-as-great-as-we-think-3b3551c440b1)
   *   Sidenote, this totally should be a protected method, but there isn't such.
   *   And it can't be private because inherited classes need to access it.
   * @param  {string[]} methods array of method names that should be binded.
   */
  bind(methods) {
    methods.map(method => {
      this[method] = this[method].bind(this);
    });
  }

  /**
   * override this with your own method. The point is to isolate from the
   * entire app state only the part that concerns the component,
   * and only observe changes in that sub state.
   * @param  {object} state receives the app state from controller app
   * @return {object} the isolated sub state, for example state.calculator.calculatorType
   */
  filterState(state) {
    return state;
  }

  /**
   * Initializes this component with the state it gets from the controller app.
   */
  initState() {
    this.setState(this.filterState(this.app.getState()));
  }

  /**
   * receives updated state, and decides if render is needed
   * @param {object} nextState app state. Receives what filterstate returns after being called by stateObserver
   */
  setState(nextState) {
    if (!isEqual(this.state, nextState)) {
      this.state = nextState;
      this.render();
    }
  }

  /**
   * Override this with your component class. This is called when setState decides
   * something has changed in the state and an update is needed.
   */
  render() {}
}

export default CarPageBasicComponent;
